import { colors } from '@resurs/midas'
import logo from '../../assets/img/logo.svg'

export default {
  hero: {
    h1: {
      color: colors.gray0,
      fontSize: '2.3rem',
      lineHeight: '2rem',
      fontWeight: 300,
    },
    logo: {
      display: 'inline-block',
      width: '15rem',
      height: '4.4rem',
      background: `url(${logo}) no-repeat`,
      backgroundSize: '100%',
    },
  },
  pushTop: {
    marginTop: '6rem',
  },
}
